// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/models/checking/onboarding/card-customization.ts
// TODO(cvu): eventually import this from dashboard via bazel

export enum SignatureFont {
  AlexBrush = "Alex Brush",
  Allura = "Allura",
  AmaticSC = "Amatic SC",
  AnnieUseYourTelescope = "Annie Use Your Telescope",
  DancingScript = "Dancing Script",
  GreatVibes = "Great Vibes",
  IndieFlower = "Indie Flower",
  Kristi = "Kristi",
  LaBelleAurore = "La Belle Aurore",
  MeieScript = "Meie Script",
  MrsSaintDelafield = "Mrs Saint Delafield",
  NanumPenScript = "Nanum Pen Script",
  OvertheRainbow = "Over the Rainbow",
  Qwigley = "Qwigley",
  ReenieBeanie = "Reenie Beanie",
  SueEllenFrancisco = "Sue Ellen Francisco",
}

export const SIGNATURE_FONT_MEMBERS = Object.values(SignatureFont);
